<div class="cb-max-100 flex-col flex start-start">
    <mat-card class="cb-margin-bottom" style="width: 100%">
        <mat-card-content class="mat-card-content-row">
            @if (displayCompare$ | async) {
                <button mat-raised-button class="cb-margin-right" (click)="goBackToList()">
                    <mat-icon>arrow_back</mat-icon>
                    &nbsp;Back to Takeoff
                </button>
            }
            <span class="flex"></span>
            @if (comparison$ | async) {
                <div class="end-center flex-row">
                    @if ((displayCompare$ | async) && !isTakeOffBudgetsEnabled()) {
                        <cb-button class="cb-margin-right" [disabled]="true">
                            Refresh Rates from Catalogue
                        </cb-button>
                    }
                    @if ((rateVariations$ | async)?.length > 0) {
                        <cb-button
                            class="cb-margin-right"
                            color="warn"
                            (clicked)="showRateVariationDialog('rateVariations')"
                        >
                            Price variations found ({{
                                (rateVariations$ | async | cbCallback: quotedVariationFilter)
                                    ?.length || 0
                            }})
                        </cb-button>
                    }
                    @if (!isTakeOffBudgetsEnabled()) {
                        <cb-button
                            class="cb-margin-right"
                            (clicked)="resolveAll()"
                            [disabled]="true"
                            >Resolve All
                        </cb-button>
                    }
                    <cb-button
                        class="cb-margin-right"
                        [disabled]="
                            (hasRateVariations$ | async) || (allVariations$ | async)?.length < 1
                        "
                        (clicked)="save()"
                        >Save
                    </cb-button>
                    <cb-button (clicked)="abandon()">Abandon</cb-button>
                </div>
            }
        </mat-card-content>
    </mat-card>
    <form class="flex flex-row" style="width: 100%" #form="ngForm">
        @if ((allVariations$ | async) && (allVariations$ | async)?.length < 1) {
            <div class="cb-margin">
                <mat-icon class="mat-accent material-icons"> info </mat-icon>
                &nbsp;No changes were found
            </div>
        }
        @if (!(comparison$ | async)) {
            <cb-loading-spinner class="cb-margin"> </cb-loading-spinner>
        }
        @if ((allVariations$ | async)?.length > 0) {
            <mat-card class="cb-margin-right cb-left-window flex">
                <mat-card-content>
                    <mat-tab-group mat-stretch-tabs="false">
                        @for (stage of (comparison$ | async)?.stages; track stage) {
                            <mat-tab [label]="stage.name + ' (' + itemCount(stage) + ')'">
                                <div class="standardTable flex-fill">
                                    <table>
                                        <thead>
                                            <tr>
                                                <td></td>
                                                <td>Code</td>
                                                <td>Item</td>
                                                <td>Original Quantity</td>
                                                <td style="text-align: right">Quantity</td>
                                                <td style="text-align: center">UOM</td>
                                                <td style="text-align: right">Imp Rate</td>
                                                <td style="text-align: right">Cat Rate</td>
                                                <td>Supplier</td>
                                                @if (!isTakeOffBudgetsEnabled()) {
                                                    <td>Cost Type</td>
                                                }
                                                @if (isTakeOffBudgetsEnabled()) {
                                                    <td style="text-align: right">Orig Budget</td>
                                                }
                                                @if (isTakeOffBudgetsEnabled()) {
                                                    <td style="text-align: right">Imp Budget</td>
                                                }
                                                <td style="text-align: center">Not in Spec</td>
                                                <td style="text-align: center">Not in Take Off</td>
                                            </tr>
                                        </thead>
                                        @for (activity of stage.activities; track activity) {
                                            <tbody>
                                                <tr class="take-off-activity">
                                                    <td style="width: 30px">
                                                        @if (activity.notes) {
                                                            <cb-info-popup
                                                                icon="insert_drive_file"
                                                                [tooltip]="activity.notes"
                                                            >
                                                            </cb-info-popup>
                                                        }
                                                    </td>
                                                    <td>{{ activity.code }}</td>
                                                    <td>{{ activity.name }}</td>
                                                    <td colspan="10"></td>
                                                    @if (isTakeOffBudgetsEnabled()) {
                                                        <td></td>
                                                    }
                                                </tr>
                                                @for (item of activity.items; track item) {
                                                    <tr>
                                                        <td class="actions">
                                                            @if (item.originalNotes) {
                                                                <cb-info-popup
                                                                    icon="content_copy"
                                                                    [tooltip]="item.originalNotes"
                                                                >
                                                                </cb-info-popup>
                                                            }
                                                            @if (item.notes) {
                                                                <cb-info-popup
                                                                    icon="insert_drive_file"
                                                                    [tooltip]="item.notes"
                                                                >
                                                                </cb-info-popup>
                                                            }
                                                        </td>
                                                        <td>
                                                            {{
                                                                item.quoteLineId == undefined
                                                                    ? item.code
                                                                    : 'Q' + item.quoteLineId
                                                            }}
                                                        </td>
                                                        <td>{{ item.name }}</td>
                                                        <td
                                                            style="text-align: right"
                                                            [ngClass]="{
                                                                'table-warn':
                                                                    $any(item).$quantitywarning
                                                            }"
                                                        >
                                                            {{ item.originalQuantity | cbDasher }}
                                                        </td>
                                                        <td
                                                            style="text-align: right"
                                                            [ngClass]="{
                                                                'table-warn':
                                                                    $any(item).$quantitywarning
                                                            }"
                                                        >
                                                            {{ item.quantity }}
                                                        </td>
                                                        <td style="text-align: center">
                                                            {{ item.uom }}
                                                        </td>
                                                        <td
                                                            style="text-align: right"
                                                            [ngClass]="{
                                                                'table-warn': $any(item).$warning
                                                            }"
                                                        >
                                                            {{ item.takeOffRate | cbCurrency }}
                                                        </td>
                                                        <td
                                                            style="text-align: right"
                                                            [ngClass]="{
                                                                'table-warn': $any(item).$warning
                                                            }"
                                                        >
                                                            {{ item.catalogueRate | cbCurrency }}
                                                        </td>
                                                        <td>{{ item.supplier | cbDasher }}</td>
                                                        @if (!isTakeOffBudgetsEnabled()) {
                                                            <cb-td-enum
                                                                [value]="item.costType"
                                                                [enum]="COST_TYPE_ENUM"
                                                            >
                                                            </cb-td-enum>
                                                        }
                                                        @if (isTakeOffBudgetsEnabled()) {
                                                            <td
                                                                style="text-align: right"
                                                                [ngClass]="{
                                                                    'table-warn':
                                                                        $any(item).$budgetWarning
                                                                }"
                                                            >
                                                                {{
                                                                    item.hasBudget
                                                                        ? (item.originalBudget
                                                                          | cbCurrency)
                                                                        : ''
                                                                }}
                                                            </td>
                                                        }
                                                        @if (isTakeOffBudgetsEnabled()) {
                                                            <td
                                                                style="text-align: right"
                                                                [ngClass]="{
                                                                    'table-warn':
                                                                        $any(item).$budgetWarning
                                                                }"
                                                            >
                                                                {{
                                                                    item.hasBudget
                                                                        ? (item.budget | cbCurrency)
                                                                        : ''
                                                                }}
                                                            </td>
                                                        }
                                                        <td style="text-align: center">
                                                            <mat-icon
                                                                >{{
                                                                    item.isNotInSpec
                                                                        ? 'check_box'
                                                                        : 'check_box_outline_blank'
                                                                }}
                                                            </mat-icon>
                                                        </td>
                                                        <td style="text-align: center">
                                                            <mat-icon
                                                                >{{
                                                                    item.isNotInTakeOff
                                                                        ? 'check_box'
                                                                        : 'check_box_outline_blank'
                                                                }}
                                                            </mat-icon>
                                                        </td>
                                                    </tr>
                                                }
                                                <tr class="empty-table-row">
                                                    <td colspan="13"></td>
                                                    @if (isTakeOffBudgetsEnabled()) {
                                                        <td></td>
                                                    }
                                                </tr>
                                            </tbody>
                                        }
                                    </table>
                                </div>
                            </mat-tab>
                        }
                    </mat-tab-group>
                </mat-card-content>
            </mat-card>
        }
        @if ((allVariations$ | async)?.length < 1) {
            <div class="flex"></div>
        }
        @if (comparison$ | async) {
            <mat-card class="flex-row flex end-center" id="alerts">
                <mat-card-content>
                    <div class="start-start flex-col flex">
                        <div class="start-start flex-row" style="margin-bottom: 10px">
                            <mat-icon style="margin-right: 8px">announcement</mat-icon>
                            <h1 class="mat-body-2">
                                <b>Alerts</b>
                            </h1>
                        </div>
                        @for (
                            variationsWithoutCatalogueRate of variationsWithoutCatalogueRates$
                                | async
                                | cbCallback: quotedVariationFilter;
                            track variationsWithoutCatalogueRate
                        ) {
                            <cb-alert-card-new
                                type="error"
                                style="width: 100%; margin-bottom: 4px"
                                message="Item
                                           {{ variationsWithoutCatalogueRate.name }} has no
                                           Catalogue Rate"
                            >
                            </cb-alert-card-new>
                        }
                        @if ((rateVariations$ | async)?.length > 1) {
                            <cb-alert-card-new
                                type="error"
                                message="There are {{ (rateVariations$ | async)?.length }}
                                            Rate
                                            Variances
                                            that need resolving"
                                style="width: 100%; margin-bottom: 4px"
                            >
                            </cb-alert-card-new>
                        }
                        @if (
                            (rateVariations$ | async)?.length > 0 &&
                            (!isTakeOffBudgetsEnabled() || (hasRateVariations$ | async))
                        ) {
                            <cb-alert-card-new
                                type="error"
                                message="There is {{ (rateVariations$ | async)?.length }}
                                Rate
                                Variance
                                that needs resolving"
                                style="width: 100%; margin-bottom: 4px"
                            >
                            </cb-alert-card-new>
                        }
                        @for (
                            lotSpecItemNotInTakeoff of (comparison$ | async)
                                ?.lotSpecItemsNotInTakeoff;
                            track lotSpecItemNotInTakeoff
                        ) {
                            @if (lotSpecItemNotInTakeoff.productId) {
                                <cb-alert-card-new
                                    type="warning"
                                    message="Lot Spec
                                Item {{
                                        lotSpecItemNotInTakeoff.productDisplay
                                    }} is not Included in the Takeoff Data"
                                    style="width: 100%; margin-bottom: 4px"
                                >
                                </cb-alert-card-new>
                            }
                        }
                        @if (noAlerts$ | async) {
                            <span class="mat-body-2">
                                <mat-icon class="mat-accent">info_circle</mat-icon>
                                &nbsp;There are no alerts to display
                            </span>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
        }
    </form>
</div>
